import { render, staticRenderFns } from "./Sector.vue?vue&type=template&id=39d24c60&scoped=true"
import script from "./Sector.vue?vue&type=script&lang=js"
export * from "./Sector.vue?vue&type=script&lang=js"
import style0 from "./Sector.vue?vue&type=style&index=0&id=39d24c60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d24c60",
  null
  
)

export default component.exports